import * as React from "react";
const CloseGreyIcon = (props) => (
  <svg
    width={18}
    height={18}
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect width={18} height={18} rx={9} fill="#8A92A6" />
    <path
      d="M8.99972 8.14076L11.9999 5.14062L12.8569 5.99763L9.85673 8.99777L12.8569 11.9979L11.9999 12.8549L8.99972 9.85478L5.99959 12.8549L5.14258 11.9979L8.14271 8.99777L5.14258 5.99763L5.99959 5.14062L8.99972 8.14076Z"
      fill="url(#paint0_linear_6839_66573)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_6839_66573"
        x1={9.34275}
        y1={5.14062}
        x2={19.3218}
        y2={22.2514}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset={1} stopColor="#F4F4F4" />
      </linearGradient>
    </defs>
  </svg>
);
export default CloseGreyIcon;
